export const beatBlipSubscriptionConsts = {
     pagesSize: [100,50,25,20,10],
     perpageitem: 100,
     version: '5.28.0',
     Octa:'false',
     ADOCheck: false,
     BASE_URL: '/HuLoopRest/huloop',
     DUPLICATE_CODE: '1105',
     ORGANIZATION_ALREADY_EXIST_CODE: '1155',
     EMAIL_FORMAT_INVALID_CODE: '1108',
     WRONG_PASSWORD_LENGTH_CODE: '1111',
     WRONG_PASSWORD_CHAR_CODE: '',
     DUPLICATE: 'User already exists',
     ORGANIZATION_ALREADY_EXIST: 'Company account already registered please contact Administrator',
     EMAIL_FORMAT_INVALID_MSG: '',
     WRONG_PASSWORD_LENGTH_MSG: '',
     SIGNUP_INFO: 'Sign up successful, we have sent a verification email to your registered email ID. Kindly verify your email.',
     USER_ID_NOT_EXIST_CODE: '1104',
     USER_ID_NOT_EXIST: 'No user exist with this user ID',
     WRONG_PASSWORD_ATTEMPTS_CODE: '5026',
     COMPANY_ACCOUNT_INACVTIVE_CODE: '1109',
     FEATURE_SUBSCRIBE: 'Thank you for subscribing to this feature . We\'ll be in touch with you soon for the next steps',
     MULTIPLE_FEATURE_SUSBSCRIBE :'Thank you for subscribing to these features . We\'ll be in touch with you soon for the next steps',
     NO_FEATURE_SELECTED :'Kindly select a feature to subscribe by clicking on the checkbox against the feature',
     LOGOUT_SUCCESSFULLY :'You have successfully logged out!!',
     UNSUBSCRIBE_FEATURE_SELECTED :'Selected feature unsubscribed successfully',
     PASSWORD_CHANGED :'Password changed successfully',
     FORGOT_PASSWORD: 'Password reset link is sent to your email id',
     TYPE_ADMIN:'Admin',
     ENCRYPTION_KEY:'beat_blip_subs_key',
     NO_PROJECT_FOR_USER :'You do not have any project to associate',
     SESSION_EXPIRED:'Your session has expired. Please login again',
     DIFFERENT_BROWSER_LOGIN:'It seems, you are logged in from other browser too, please relogin',
     CUTOMER_TOKEN_EXPIRED:'Customer Access Token has been expired',
     CUSTOMER_PASSWORD_REUSE_PROHIBITED: '93300',
     type: {
          PROJECT: 'P',
          TEST_SUITE_DIR: 'D',
          TEST_SUITE_FILE: 'F',
          TEST_SUITE_SHARE_FILE: 'SF',
          TEST_CASE: 'C',
          LOCATOR_SUITE_DIR: 'LD',
          LOCATOR_SUITE: 'LS'
      },
      project: {
          DUPLICATE: 'Project name is already exists',
          SAVED: 'Project is created successfully',
          ERROR_IN_LOADING: 'There is error in loading project',
          DELETED: 'Project is deleted successfully',
          SELECT: 'Please select a project',
          RENAMED: 'Project renamed successfully'
      },
     dialogflow:{
          angularBot : '1eeea8eaab56422fa03a0e6ad71ee208'
     },
     AGREEYA_SF_URL:'',
     iconList : {
          "AI" : "fas fa-robot",
          "Banking": "fas fa-university",
          "Healthcare": "fas fa-medkit",
          "Technology": "fas fa-laptop",
          "Real estate": "fas fa-building",
          "Retail": "fas fa-store",
          "Insurance": "fas fa-heartbeat",
          "Supply chain": "fas fa-truck",
          "Hospitality" : "fas fa-praying-hands",
          "Finance": "fas fa-hand-holding-usd",
          "FMCG" :"fas fa-utensils",
          "Trade": "fas fa-chart-line",
          "Education": "fas fa-book-reader",
          "Media": "fas fa-bullhorn",
          "Entertainment": "fas fa-icons",
          "Sales": "fas fa-coins",
          "Construction" : "fas fa-tools",
          "Automobile": "fas fa-car",
          "Telecom": "fas fa-satellite-dish",
          "Pharma" : "fas fa-pills"
        },

     colorList : {
          "Blue": "#002d5b",
          "Green": "#39b54a",
          "Light Grey": "#d8d9da",
          "Light Blue": "#a6dbf0",
          "Yellow": "#ffba08",
          "Red": "#d56128"
     },
     images: {
          "Andrew Autonomous" : "bot-andrew-autonomous-processing-agent-cropped.png",
           "Andy Account" : "bot-andy-account-mgmt-agent-cropped.png",
          "Betty Goodbuy": "bot-betty-goodbuy-purchasing-agent-cropped.png",
          "Catman Category": "bot-catman-category-mgmt-agent-cropped.png",
          "Collections Colleen": "bot-collections-colleen-collections-agent-cropped.png",
          "Danny Datadude": "bot-danny-datadude-data-integrity-agent-cropped.png",
          "Digital Daisy": "bot-digital-daisy-digital-commerce-agent-cropped.png",
          "Document Diana": "bot-document-diana-document-agent-cropped.png",
          "Freddy Fileman": "bot-freddy-fileman-file-agent-cropped.png",
          "Helpful Harry": "bot-helpful-harry-support-agent-cropped.png",
          "HR Hazel" : "bot-hr-hazel-hr-agent-cropped.png",
           "Kyc Katrina" : "bot-kyc-katrina-customer-agent-cropped.png",
          "Lending Leo" : "bot-lending-leo-loan-agent-cropped.png",
          "Loyalty Larry": "bot-loyalty-larry-loyalty-agent-cropped.png",
           "Mark Keting" :"bot-mark-keting-marketing-agent-cropped.png",
          "Merchandising molly": "bot-merchandising-molly-merchandising-agent-cropped.png",
          "Nancy Numbers": "bot-nancy-numbers-accounting-agent-cropped.png",
          "Ozzy Operations": "bot-ozzy-operations-agent-cropped.png",
          "Penny Priceright": "bot-penny-priceright-pricing-agent-cropped.png",
          "Polly Planner": "bot-polly-planner-finance-agent-cropped.png",
          "Randy Rainmaker" : "bot-randy-rainmaker-sales-agent-cropped.png",
          "Sammy Salesjump": "bot-sammy-salesjump-promotions-agent-cropped.png",
          "Sara Service": "bot-sara-service-customer-agent-cropped.png",
          "Stan Stockman" : "bot-stan-stockman-inventory-agent-cropped.png",
          "Tony Tester" : "bot-tony-tester-testing-agent-cropped.png",
          "Trent Truckswell" : "bot-trent-truckswell-transportation-agent-cropped.png",
           "Trudy Treasury" : "bot-trudy-treasury-agent-cropped.png"
      },
      icons:{
          "AI" : "fas fa-robot",
          "Banking": "fas fa-university",
          "Healthcare": "fas fa-medkit",
          "Technology": "fas fa-laptop",
          "Real estate": "fas fa-building",
          "Retail": "fas fa-store",
          "Insurance": "fas fa-heartbeat",
          "Supply chain": "fas fa-truck",
          "Hospitality" : "fas fa-praying-hands",
          "Finance": "fas fa-hand-holding-usd",
          "FMCG" :"fas fa-utensils",
          "Trade": "fas fa-chart-line",
          "Education": "fas fa-book-reader",
          "Media": "fas fa-bullhorn",
          "Entertainment": "fas fa-icons",
          "Sales": "fas fa-coins",
          "Construction" : "fas fa-tools",
          "Automobile": "fas fa-car",
          "Telecom": "fas fa-satellite-dish",
          "Pharma" : "fas fa-pills"
      }
    };
